
      import App from './app/app';
      import environment from 'beebeeboard-booking/config/environment';

      App.create(environment.APP);
    